module.exports = __webpack_public_path__ + "static/img/smartProduct23.0765ec26.png";